import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './hooks/useAuth';
import { extractSessionFromUrl } from './hooks/useSessionToken';
import './index.css';

// Extract session token from URL before React renders (critical for auth redirect)
extractSessionFromUrl();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);
